const routes = [
  {
    path: '/magic',
    name: 'magic',
    component: () => import('@/modules/buffer/MagicLinkBuffer.vue'),
  },
];

export default routes;
